import { checkDate } from "./checkDate";

export function calculateAge(dob) {
    if(dob && checkDate(dob)){
        var today = new Date();
        var birthDate = new Date(dob);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())){
            age--;
        }
        return age;
    }
    else{
        return null;
    }
}